import React, { lazy } from 'react';
export function GuaranteeSection() {
  return <section className="py-24 bg-black" data-id="element-91">
      <div className="container mx-auto px-4" data-id="element-92">
        <div className="max-w-4xl mx-auto glass-card p-10 md:p-16 rounded-3xl text-center" data-id="element-93">
          <img src="https://cdn-icons-png.flaticon.com/512/9370/9370213.png" alt="Garantía de 72hs" width="80" height="80" loading="lazy" decoding="async" className="w-20 h-20 mx-auto mb-8 opacity-90 drop-shadow-lg" data-id="element-94" />
          <p className="text-purple-400 font-bold uppercase tracking-widest text-sm mb-4" data-id="element-95">
            🔒 Cero riesgo para vos
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-96">
            Garantía de Funcionamiento 72hs
          </h2>
          <p className="text-gray-400 leading-relaxed text-lg md:text-xl mb-4 max-w-2xl mx-auto" data-id="element-97">
            Si la app presenta errores técnicos que impidan su uso, te
            devolvemos el 100% dentro de las primeras 72 horas.
          </p>
          <p className="text-gray-500 text-base mb-10 max-w-xl mx-auto italic" data-id="element-98">
            100Ads no es para curiosos. Es para dueños de productos digitales
            que quieren escalar con volumen real.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 font-bold uppercase tracking-wider" data-id="element-99">
            <span className="flex items-center gap-2" data-id="element-100">
              🔒 Reembolso garantizado
            </span>
            <span className="hidden md:inline text-white/10" data-id="element-101">|</span>
            <span className="flex items-center gap-2" data-id="element-102">
              📧 Soporte por email
            </span>
            <span className="hidden md:inline text-white/10" data-id="element-103">|</span>
            <span className="flex items-center gap-2" data-id="element-104">⚡ Proceso en 24hs</span>
          </div>
        </div>
      </div>
    </section>;
}